/* istanbul ignore file */
import { defineMessages } from 'react-intl';

export const en_us = defineMessages({
  title: {
    id: `pib_seo_title_en`,
  },
  description: {
    id: `pib_seo_description_en`,
  },
});

export const es = defineMessages({
  title: {
    id: `pib_seo_title_es`,
  },
  description: {
    id: `pib_seo_description_es`,
  },
});
